"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSVOption = void 0;
var CSVOption = /** @class */ (function () {
    function CSVOption() {
        this.includeHeader = true;
        this.fieldSep = ',';
        this.recordSep = '\n';
        this.quoteChar = '"';
        this._fieldAndRecord = this.fieldSep + this.recordSep;
    }
    CSVOption.prototype.setFieldSep = function (fieldSep) { this.fieldSep = fieldSep; return this.buildTerm(); };
    CSVOption.prototype.setRecordSep = function (recordSep) { this.recordSep = recordSep; return this.buildTerm(); };
    CSVOption.prototype.setQuoteChar = function (quoteChar) { this.quoteChar = quoteChar; return this; };
    CSVOption.prototype.setIncludeHeader = function (includeHeader) { this.includeHeader = includeHeader; return this; };
    CSVOption.prototype.buildTerm = function () {
        this._fieldAndRecord = this.fieldSep + this.recordSep;
        return this;
    };
    return CSVOption;
}());
exports.CSVOption = CSVOption;
//# sourceMappingURL=CSVOption.js.map